"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadTransaction = void 0;

var threads_pb_1 = require("@textile/threads-client-grpc/threads_pb");

var Transaction_1 = require("./Transaction");

var decoder = new TextDecoder();
var encoder = new TextEncoder();
/**
 * ReadTransaction performs a read-only bulk transaction on the underlying store.
 * {@inheritDoc @textile/threads-client#Transaction}
 * @example
 * Create a new entry and check for it within a transaction
 * ```typescript
 * import {Client, ThreadID} from '@textile/threads'
 *
 * interface Astronaut {
 *   name: string
 *   missions: number
 *   _id: string
 * }
 *
 * async function createAndCheck (client: Client, threadID: ThreadID) {
 *   const buzz: Astronaut = {
 *     name: 'Buzz',
 *     missions: 2,
 *     _id: '',
 *   }
 *
 *   const ids = await client.create(threadID, 'astronauts', [buzz])
 *   // Create and start transaction
 *   const t = client.readTransaction(threadID, 'astronauts')
 *   await t.start()
 *   const has = await t.has(ids)
 *   console.log(has) // true
 *   await t.end() // Finish
 * }
 * ```
 */

var ReadTransaction = /*#__PURE__*/function (_Transaction_1$Transa) {
  _inherits(ReadTransaction, _Transaction_1$Transa);

  var _super = _createSuper(ReadTransaction);

  function ReadTransaction(context, client, threadID, modelName) {
    var _this;

    _classCallCheck(this, ReadTransaction);

    _this = _super.call(this, client, threadID, modelName);
    _this.context = context;
    _this.client = client;
    _this.threadID = threadID;
    _this.modelName = modelName;
    return _this;
  }
  /**
   * start begins the transaction. All operations between start and end will be applied as a single transaction upon a call to end.
   */


  _createClass(ReadTransaction, [{
    key: "start",
    value: function start() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var startReq, req, metadata;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                startReq = new threads_pb_1.StartTransactionRequest();
                startReq.setDbid(this.threadID.toBytes());
                startReq.setCollectionname(this.modelName);
                req = new threads_pb_1.ReadTransactionRequest();
                req.setStarttransactionrequest(startReq);
                metadata = JSON.parse(JSON.stringify(this.context));
                this.client.start(metadata);
                this.client.send(req);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * has checks whether a given instance exists in the given store.
     * @param IDs An array of instance ids to check for.
     */

  }, {
    key: "has",
    value: function has(IDs) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var hasReq = new threads_pb_1.HasRequest();
                  hasReq.setInstanceidsList(IDs);
                  var req = new threads_pb_1.ReadTransactionRequest();
                  req.setHasrequest(hasReq);

                  _this2.client.onMessage(function (message) {
                    var reply = message.getHasreply();
                    var err = reply === null || reply === void 0 ? void 0 : reply.getTransactionerror();

                    if (err) {
                      reject(new Error(err));
                    }

                    resolve(reply && reply.getExists());
                  });

                  _this2.setReject(reject);

                  _this2.client.send(req);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * find queries the store for entities matching the given query parameters. See Query for options.
     * @param query The object that describes the query. See Query for options. Alternatively, see QueryJSON for the basic interface.
     */

  }, {
    key: "find",
    value: function find(query) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve, reject) {
                  var findReq = new threads_pb_1.FindRequest();
                  findReq.setQueryjson(encoder.encode(JSON.stringify(query)));
                  var req = new threads_pb_1.ReadTransactionRequest();
                  req.setFindrequest(findReq);

                  _this3.client.onMessage(function (message) {
                    var reply = message.getFindreply();
                    var err = reply === null || reply === void 0 ? void 0 : reply.getTransactionerror();

                    if (err) {
                      reject(new Error(err));
                    }

                    if (reply === undefined) {
                      resolve([]);
                    } else {
                      var ret = reply.getInstancesList_asU8().map(function (instance) {
                        return JSON.parse(decoder.decode(instance));
                      });
                      resolve(ret);
                    }
                  });

                  _this3.setReject(reject);

                  _this3.client.send(req);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * findByID queries the store for the id of an instance.
     * @param ID The id of the instance to search for.
     */

  }, {
    key: "findByID",
    value: function findByID(ID) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new Promise(function (resolve, reject) {
                  var findReq = new threads_pb_1.FindByIDRequest();
                  findReq.setInstanceid(ID);
                  var req = new threads_pb_1.ReadTransactionRequest();
                  req.setFindbyidrequest(findReq);

                  _this4.client.onMessage(function (message) {
                    var reply = message.getFindbyidreply();
                    var err = reply === null || reply === void 0 ? void 0 : reply.getTransactionerror();

                    if (err) {
                      reject(new Error(err));
                    }

                    if (reply === undefined) {
                      resolve(undefined);
                    } else {
                      resolve(JSON.parse(decoder.decode(reply.getInstance_asU8())));
                    }
                  });

                  _this4.setReject(reject);

                  _this4.client.send(req);
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return ReadTransaction;
}(Transaction_1.Transaction);

exports.ReadTransaction = ReadTransaction;